import { COVERGO_SAAS_DEV } from "../consts.js"

export const mopoc_dev = {
	"mopoc-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "mopoc_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
}
